import { bet, checkOnHoldBetStatus } from "../../js/api/betting.js";
import { getCurrentBalance } from "../../js/api/balance.js";
import { mybet, repeatbetinfo } from "../../js/api/myBet.js";
import { getGamePrintDetails } from "../templates/print.js";
import { getUsers } from "../../js/api/users.js";
import { _t } from "../../services/TranslationService.js";
import { getMatchByCode, getMatch } from "../../js/api/singleMatch.js";
import { generateRowView } from "../templates/mybetsrow.js";
import Utils from "../../services/Utils.js";

import {
  repeatLastBet,
  betdetailsbynumber,
  cancelbetbynumber,
} from "../../js/api/myBet.js";

let playedValue = 0;
let Betslip = {
  render: async () => {
    let betItem = "";
    (JSON.parse(localStorage.getItem("addObject")) || []).forEach((item, i) => {
      betItem += `
                <div 
                    class="betSlipSingleItem flex flex-row flex-wrap relative bg-black/40 w-full px-1 py-[1px] mb-[1px] odd:bg-black/60 last:border-none" 
                    game-id="${item.gameId}" 
                    bet-id="${item.coefId}"
                >
                    <div class="betSlipSingleContent flex flex-wrap flex-row flex-1">
                        <div class="betSlipSingleDetails flex flex-wrap flex-row relative w-full">
                            <span class="betSlipSingleMatch flex flex-wrap flex-row text-white text-[11px] w-[35px]">${
                              item.getGameCode
                            }</span>
                            <span class="betSlipSingleMatch flex flex-wrap flex-row text-white text-[11px] w-[270px]">${
                              item.getHomeName
                            } - ${item.getAwayName}</span>
                            <span class="betSlipSingleType flex flex-wrap flex-row text-white text-[10px] w-[160px] justify-start">${
                              item.matchMarket
                            } ( ${item.marketOption})</span>
                            <div class="betSlipSingleOdd flex flex-wrap flex-row justify-end text-white text-[11px] w-[30px] ${
                              item.coefId
                            }-bs text-white">
                                ${
                                  item.oldCoefVal
                                    ? `<span style=" text-decoration: line-through;">${Utils.formatNumber(
                                        item.oldCoefVal
                                      )}</span><span style="color:${
                                        parseFloat(
                                          Utils.formatNumber(item.coefVal)
                                        ) >
                                        parseFloat(
                                          Utils.formatNumber(item.oldCoefVal)
                                        )
                                          ? "green"
                                          : "red"
                                      }">${Utils.formatNumber(
                                        item.coefVal
                                      )}</span>`
                                    : `<span>${Utils.formatNumber(
                                        item.coefVal
                                      )}</span>`
                                }
                            </div>
                        </div>
                    </div>
                    <div class="removeBetBtn w-[14px] h-[14px] p-0 cursor-pointer">
                        <img src="./img/x.gif" class="w-full h-full object-contain object-center" />
                    </div>
                </div>
            `;
    });

    let view = /*html*/ `
            <div id="betModalDetail" class="-translate-x-full duration-0 ease-in-out pointer-events-none fixed bg-black/10 flex top-0 left-0 w-screen h-screen z-50 items-center flex-row flex-wrap justify-center">

            </div>
            <div class="betSlip w-full flex flex-col flex-wrap relative h-[calc(100vh-92px)] shadow-[3px_3px_3px_#000000]" id="mainBetslip">
                <div class="betSlipHeader w-full flex flex-wrap flex-row bg-black space-x-2 items-center relative">
                    <div class="betHeaderTitle flex">
                        <span class="text-white text-[12px] font-bold p-1">${
                          localStorage.getItem("role") == "Agent"
                            ? ``
                            : "Skedina"
                        }</span>
                        ${
                          localStorage.getItem("role") == "Agent"
                            ? `
                            <select name="userSelect" class="userSelect" id="userSelect">
                                <option value="">${_t("Zgjidh nje")}</option>
                                ${await renderChildUsers()}
                            </select>
                        `
                            : ""
                        }
                    </div>
                    <div class="betHeaderCoef hidden">
                        <span id="betCoefCount"></span>
                    </div>
                    <div class="betBalance hidden">
                        <span>${_t("Balance")}</span>
                        <span><i>0.00</i></span>
                    </div>
                </div>
                <div class="closeModal cursor-pointer absolute right-1 top-1 h-[18px] w-[18px] justify-center items-center flex p-0 p-[2px]">
                    <img src="./img/x.gif" class="w-full h-full object-contain object-center" />
                </div>
                <div class="betTypeWrapper multipleActive hidden">
                    <div class="multipleBtn">
                        <a class="singleBtn">${_t("Multiple")}</a>
                    </div>
                    <div class="systemBtn disabledBtn">
                        <select name="" id="systemBtn">
                        </select>
                    </div>
                    <div class="line-active"></div>
                </div>
                <div class="betSlipContent w-full flex flex-wrap flex-row content-start bg-gradient-to-t from-[#232323] to-[#494949] overflow-y-scroll h-[calc(100vh-490px)]">
                    <div class="flex flex-row flex-wrap w-full space-y-1 hideThisWhenClear">
                        <div class="w-full flex flex-wrap flex-row bg-[rgba(0,0,0,.5)] text-white items-center p-1 justify-center space-x-2">
                            <span class="text-[11px]">Data/Ora: </span><span class="date-now text-[#e4cc23] font-bold text-[11px]"></span>
                        </div>
                        <div class="w-full flex flex-wrap flex-row bg-[rgba(0,0,0,.5)] text-white">
                            <div class="flex w-1/2 flex-row flex-wrap items-center justify-between p-1">
                                <span class="text-[11px]">Nr. Biletes:</span>
                                <input  class="betdetailsbynumber w-[100px] h-[20px] text-[11px] bg-white/20 border text-white font-bold px-1 focus:bg-gradient-to-b focus:from-[#a90329] focus:via-[#8f0222] focus:to-[#6d0019]" />
                                <button class="search-ticket bg-black text-white text-[11px] font-bold p-1">Kerko</button>
                            </div>
                            <div class="flex w-1/2 flex-row flex-wrap items-center justify-between p-">
                                <span class="text-[11px]">Nr. Biletes:</span>
                                <input class="betrejectnumber w-[100px] h-[20px] text-[11px] bg-white/20 border text-white font-bold px-1 focus:bg-gradient-to-b focus:from-[#a90329] focus:via-[#8f0222] focus:to-[#6d0019]" />
                                <button class="reject-last-ticket bg-black text-white text-[11px] font-bold p-1">Anullo</button>
                            </div>
                        </div>
                        <div class="w-full flex flex-wrap flex-row bg-[rgba(0,0,0,.5)] text-white items-center p-1 justify-center">
                            <button class="bg-black text-white text-[14px] font-bold py-1 px-2 repeat-last-ticket">Rivendos Skedinen e fundit</button>
                        </div>
                    </div>
                    <div class="flex flex-row flex-wrap relative bg-black/90 w-full py-[1px] px-1 mb-[1px] border-b border-dotted border-[#e4cc23] text-[#e4cc23] mt-1">
                        <span class="text-[11px] font-bold w-[35px]">Kodi</span>
                        <span class="text-[11px] font-bold w-[270px]">Pritesi - Udhetuesi</span>
                        <span class="text-[10px] font-bold w-[160px] text-left">Poz</span>
                        <span class="text-[11px] font-bold w-[30px]">Koefi</span>
                    </div>
                    ${betItem}
                </div>
                <div class="betSlipFooter flex flex-wrap flex-row relative bg-black/40 w-full">

                    <div class="flex-wrap flex-row flex w-full bg-black/90 text-[#e4cc23] text-[11px] p-1 justify-between mb-4">

                        <div class="flex flex-wrap flex-row">
                            <span class="">Ndeshje:</span>
                            <div class="betCount">
                                <span class="">${
                                  (
                                    JSON.parse(
                                      localStorage.getItem("addObject")
                                    ) || []
                                  ).length
                                }</span>
                            </div>
                        </div>

                        <div class="flex flex-wrap flex-row">
                            <span class="">Komb:</span>
                            <div class="">
                                <span class="">0</span>
                            </div>
                        </div>
                        <div class="flex flex-wrap flex-row">
                            <span class="">Koefi min:</span>
                            <div class="">
                                <span class="koefVal">1.00</span>
                            </div>
                        </div>
                        <div class="flex flex-wrap flex-row">
                            <span class="">Koefi Max:</span>
                            <div class="">
                                <span class="koefVal">1.00</span>
                            </div>
                        </div>
                    </div>

                    <div class="flex-wrap flex-row flex w-full p-1 items-center">
                        <form class="flex flex-wrap flex-row w-full justify-between">
                            <div class="flex flex-wrap flex-row items-center relative">
                                <div class="flex flex-wrap flex-row items-center w-full">
                                    <span class="text-[#e4cc23] text-[11px] font-bold mr-2">Kodi:</span>
                                    <input id="code_match" type="text" class="w-[44px] h-[20px] text-[11px] bg-white/20 border text-white font-bold px-1 focus:bg-gradient-to-b focus:from-[#a90329] focus:via-[#8f0222] focus:to-[#6d0019]" />
                                </div>
                                <span id="code-match-name" class="hidden absolute left-[24px] mt-1 top-full z-20 w-[320px] bg-black text-white bg-gradient-to-b from-[#a90329] via-[#8f0222] to-[#6d0019] shadow-md p-1 px-2 text-[11px]"></span>
                            </div>

                            <div class="relative w-[200px]">
                                <select id="native-match-select" class="w-full bg-white/20 border text-white text-[11px] h-[25px] px-2 focus:bg-gradient-to-b focus:from-[#a90329] focus:via-[#8f0222] focus:to-[#6d0019] ">
                                    <option value="">${_t(
                                      "Select an option"
                                    )}</option>
                                </select>
                            </div>

                            <div class="flex flex-wrap flex-row">
                                <button type="submit" class="bg-black text-white text-[11px] font-bold p-1">Aprovo</button>
                            </div>
                            <div class="flex flex-wrap flex-row items-center">
                                <label for="printTickets" class="text-[#e4cc23] text-[11px] font-bold mr-2 ">Printo</label>
                                <input id="printTickets" type="checkbox" class="" />
                            </div>
                        </form>
                    </div>

                    <div class="flex-wrap flex-row flex w-full bg-black/90 text-[#e4cc23] text-[11px] p-1 justify-between">
                        <div class="flex flex-wrap flex-row">
                            <span class="">Fitimi Min:</span>
                            <div class="">
                                <span class=""></span>
                            </div>
                        </div>
                        <div class="flex flex-wrap flex-row">
                            <span class="">Fitimi Max:</span>
                            <div class="">
                                <span class="">0</span>
                            </div>
                        </div>
                        <div class="flex flex-wrap flex-row">
                            <span class="">Bonus Mi min:</span>
                            <div class="">
                                <span class="">1.00</span>
                            </div>
                        </div>
                        <div class="flex flex-wrap flex-row">
                            <div class="">
                                <span class="">1.00</span>
                            </div>
                        </div>
                    </div>
                    
                    <div class="flex-wrap flex-row flex w-full relative">
                        <div class="betStake flex w-1/2">
                            <span class="absolute top-0 left-0 text-[10px] text-[#a7a7a7] px-2 pt-1">${_t(
                              "Price"
                            )}</span>
                            <i class="valueIcon"></i>
                            <input 
                                class="bg-[#333] border-0 p-2 pt-4 w-full text-[#4acfa5]" 
                                type="text" 
                                inputmode="decimal" 
                                id="placeBetAreaValue" 
                                placeholder="0.00"
                                autocomplete="off" 
                                autocorrect="off" 
                                autocapitalize="off" 
                                spellcheck="false"
                            />
                        </div>
                        <div class="betPlace absolute right-0 bottom-0 w-1/2 flex flex-row flex-wrap items-center justify-center pb-1 pointer-events-none">
                            <span class=" text-[12px] text-[#74d600]">${_t(
                              "Winning Chance:"
                            )}</span>
                            <i class="valueIcon"></i>
                            <span class="text-[12px] text-[#74d600]" id="winningPrice">0.00</span>
                        </div>
                        <div class="currencyValue hidden">
                            <a class="currencySelector selected" currencyId="2">Lek</a>
                            <a class="currencySelector" currencyId="1">Euro</a>
                            <a class="currencySelector" currencyId="3">Dollar</a>
                        </div> 
                        <div class="betBtn w-1/2 bg-[#082c47] cursor-pointer flex flex-wrap flex-row justify-center pt-1" id="betBtn">
                            <span class="text-white text-center" id="btnDescription">${_t(
                              "Place Bet"
                            )}</span>
                            <span class="valueIcon" id="valueIcon"></span>
                            <span id="placeBetValue" class="hidden">0.00</span>
                        </div>
                    </div>
                </div>
                <div class="w-full flex flex-wrap flex-col bg-gradient-to-t from-[#232323] to-[#494949] h-[225px]">
                    <div class="flex flex-wrap flex-row relative justify-between bg-gradient-to-b from-[#a90329] via-[#8f0222] to-[#6d0019] w-full p-1 items-center content-center shadow-[3px_3px_3px_#000000] z-10" id="headerEvent">
                        <div class="flex flex-row flex-wrap items-center justify-center">
                            <a class="flex text-white font-[600] text-[14px] leading-[25px] h-[25px] font-sans px-2 border-l bg-[#8d741d] hover:text-black hover:bg-[rgba(245,180,1,1)]">Mesazh Nga Qendra</a>
                            <a class="flex text-white font-[600] text-[14px] leading-[25px] h-[25px] font-sans px-2 border-l bg-black bg-opacity-20 hover:text-black hover:bg-[rgba(245,180,1,1)]" onClick="openChat()">Chat</a>
                        </div>
                    </div>
                    <div class="flex flex-wrap flex-row w-full text-white p-2 text-[11px]">
                        <p>https://ufile.io/ku7gqp5i</p>
                    </div>
                </div>
            </div>
        `;
    return view;
  },
  after_render: async () => {
    const checkbox = document.getElementById("printTickets");

    // ✅ Initialize localStorage key if not existing
    if (localStorage.getItem("autoprint") === null) {
      localStorage.setItem("autoprint", "false");
    }

    // ✅ Sync initial state from localStorage
    checkbox.checked = localStorage.getItem("autoprint") === "true";

    // ✅ Update localStorage when checkbox changes
    checkbox.addEventListener("change", (e) => {
      localStorage.setItem("autoprint", e.target.checked ? "true" : "false");
    });

    $("body").on("click", ".closeViewBet", async (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      $("body #betModalDetail")
        .removeClass("translate-x-0 pointer-events-all")
        .addClass("-translate-x-full pointer-events-none");
      $("body #betModalDetail").html("");
    });

    let allowEnterToSelect = false; // Default: block Enter
    let isRequestInProgress = false; // Avoid overlapping requests
    let debounceTimer = null;
    // This helper clicks an existing bettingBtn or creates a temporary one

    $("body").on("click", ".reject-last-ticket", async function () {
      e.stopPropagation();
      e.stopImmediatePropagation();
      e.preventDefault();
      // Get the bet number from the input next to this button
      const betNumber = $(this)
        .closest("div")
        .find(".betrejectnumber")
        .val()
        .trim();

      if (!betNumber) {
        alert("Ju lutem vendosni numrin e biletës."); // “Please enter a ticket number.”
        return;
      }

      // Confirm the user really wants to cancel
      if (!confirm(`Dëshironi të anuloni biletën me numër ${betNumber}?`)) {
        return;
      }

      try {
        const result = await cancelbetbynumber(betNumber);

        // Show success message or handle the response as needed
        alert("Bileta u anulua me sukses.");

        // You might also want to clear the input or update UI elements here
        $(this).closest("div").find(".betrejectnumber").val("");
      } catch (err) {
        alert("Ndodhi një gabim gjatë anulimit të biletës.");
      }
    });

    function clickThroughBet(bet) {
      const $existing = $(
        `.bettingBtn[game-id="${bet.game_id}"][bet-id="${bet.coeficient_id}"]`
      );

      if ($existing.length) {
        $existing.trigger("click");
      } else {
        const $temp = $(`
      <div class="bettingBtn tempBettingBtn"
           game-id="${bet.game_id}"
           bet-id="${bet.coeficient_id}"
           match-odd="${bet.coeficient_value}"
           match-home-name="${bet.home_team}"
           match-away-name="${bet.away_team}"
           match-code="${bet.game_code}"
           match-market="${bet.market_name}"
           match-market-option="${bet.market_option_name}"
           match-is-live="0">
        <span>${bet.home_team}</span>
        <span>${bet.coeficient_value}</span>
      </div>
    `);

        $("body").append($temp);
        $temp.trigger("click");
        $temp.remove();
      }
    }

    // Prevent duplicate keypress bindings
    $("body")
      .off("keypress", ".betdetailsbynumber")
      .off("keydown", ".betdetailsbynumber")
      // 2) Rebind using keydown (more reliable for Enter)
      .on("keydown", ".betdetailsbynumber", function (e) {
        if (e.key === "Enter" || e.which === 13) {
          e.preventDefault();
          e.stopImmediatePropagation();

          // Trigger the *sibling* search button to avoid clicking other buttons elsewhere
          const $btn = $(this).siblings(".search-ticket").first();
          if ($btn.length) $btn.trigger("click");

          // Clear this input
          this.value = "";
        }
      });

    // Remove any previous .printTicket handlers and rebind once
    $("body")
      .off("click", ".printTicket")
      .on("click", ".printTicket", async (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        const $btn = $(e.currentTarget);

        // Prevent double-clicking while processing
        if ($btn.data("printing")) return;
        $btn.data("printing", true);

        try {
          const betId = $btn.attr("id");
          const userId = localStorage.getItem("user_id")?.toString();

          if (userId !== "38184") {
            const bet = await mybet(betId);
            const doc = getGamePrintDetails(bet);

            const printWin = window.open(
              "",
              "",
              "left=0,top=0,width=900,height=700,toolbar=0,scrollbars=0,status=0"
            );

            printWin.document.write(doc);
            printWin.document.close();
            printWin.focus();
            printWin.print();

            printWin.onafterprint = function () {
              printWin.close();
            };
          }
        } catch (err) {
          console.error("Print failed:", err);
        } finally {
          // Allow re-click after 1.5s (safety)
          setTimeout(() => $btn.removeData("printing"), 1500);
        }
      });

    // Prevent duplicate click bindings
    // Prevent duplicate click bindings
    $("body")
      .off("click", ".search-ticket")
      .on("click", ".search-ticket", async function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        const $btn = $(this);
        if ($btn.data("loading")) return; // already running
        $btn.data("loading", true).prop("disabled", true);

        // Find the paired input near this button
        const $input = $btn.closest("div").find(".betdetailsbynumber").first();
        const betNumber = ($input.val() || "").toString().trim();
        $input.val(""); // clear only this input

        if (!betNumber) {
          alert("Ju lutem vendosni numrin e biletës.");
          $btn.data("loading", false).prop("disabled", false);
          return;
        }

        try {
          const response = await betdetailsbynumber(betNumber);
          const bets = Array.isArray(response?.data) ? response.data : [];

          if (!bets.length) {
            alert("Nuk u gjetën baste për këtë numër bilete.");
            return;
          }

          const betView = generateRowView(bets, bets[0].bet_id);
          $("body #betModalDetail")
            .html(betView)
            .removeClass("-translate-x-full pointer-events-none")
            .addClass("translate-x-0 pointer-events-all");
        } catch (err) {
          console.error("Failed to fetch bet details:", err);
          alert("Ndodhi një gabim gjatë kërkimit të biletës.");
        } finally {
          $btn.data("loading", false).prop("disabled", false);
        }
      });

    document.addEventListener("input", function (e) {
      const input = e.target;
      if (input.id === "placeBetAreaValue") {
        let value = input.value;

        // Only allow digits and one dot, max 2 decimals
        value = value
          .replace(/[^0-9.]/g, "") // remove invalid chars
          .replace(/(\..*?)\..*/g, "$1") // prevent more than one dot
          .replace(/^0+([0-9])/, "$1") // remove leading zeros
          .replace(/^(\d+)(\.\d{0,2})?.*/, "$1$2"); // max 2 decimal places

        input.value = value;
      }
    });

    $(document).ready(function () {
      function updateDateNow() {
        const options = {
          timeZone: "Europe/Tirane",
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        };

        const formatter = new Intl.DateTimeFormat("en-GB", options);
        const formatted = formatter.format(new Date()).replace(",", "");

        // Update the span contents using jQuery
        $(".date-now").text(formatted);
      }

      // Update immediately, then every second
      updateDateNow();
      setInterval(updateDateNow, 1000);
    });

    $("body").on("click", ".repeat-last-ticket", async function () {
      try {
        const response = await repeatLastBet();
        const bets = response.data || [];

        bets.forEach((bet) => {
          // 1. Try to find an existing bettingBtn with matching game/bet IDs
          const selector = `.bettingBtn[game-id="${bet.game_id}"][bet-id="${bet.coeficient_id}"]`;
          const $existingBtn = $(selector);

          if ($existingBtn.length) {
            // If found, just trigger its click
            $existingBtn.trigger("click");
          } else {
            // Otherwise create a temporary button with the required attributes
            const $tempBtn = $(`
            <div class="bettingBtn tempBettingBtn"
                game-id="${bet.game_id}"
                bet-id="${bet.coeficient_id}"
                match-odd="${bet.coeficient_value}"
                match-home-name="${bet.home_team}"
                match-away-name="${bet.away_team}"
                match-code="${bet.game_code}"
                match-market="${bet.market_name}"
                match-market-option="${bet.market_option_name}"
                match-is-live="0">
                <span class="w-[75px] truncate">${bet.home_team}</span>
                <span>${bet.coeficient_value}</span>
            </div>
            `);

            // Append it off-screen or in a hidden container
            $("body").append($tempBtn);

            // Trigger the click to run your existing handler
            $tempBtn.trigger("click");

            // Remove the temporary element to clean up the DOM
            $tempBtn.remove();
            setTimeout(() => {
              $("body #placeBetAreaValue").blur();
            }, 1000);
          }
        });
      } catch (err) {
        console.error("Failed to repeat last bet:", err);
      }
    });

    $("body").on("click", ".currencySelector", function (e) {
      $(e.currentTarget).parent().children().removeClass("selected");
      $(e.currentTarget).addClass("selected");
    });

    $("body").on("click", ".quickBetBetBtn", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const code = $(this).attr("quick-code") || "";
      if (!code || code === "null") return;

      const $input = $("#code_match");

      // Set value and focus
      $input.val(code).focus();

      // Trigger keyup to start debounce logic
      $input.trigger("keyup");

      // Poll for allowEnterToSelect to become true (after debounce + match fetch)
      const interval = setInterval(() => {
        if (allowEnterToSelect) {
          clearInterval(interval);

          // Simulate Enter keypress
          const enterKeyEvent = new KeyboardEvent("keypress", {
            key: "Enter",
            bubbles: true,
            cancelable: true,
          });
          $input[0].dispatchEvent(enterKeyEvent);
        }
      }, 50); // Check every 50ms
      if ($(e.currentTarget).hasClass("normalMatch")) {
        const thisRoute = $(e.currentTarget).attr("href"); // e.g. "#/match/1957037"
        let currentUrl = window.location.href;

        // If URL contains "#/", replace everything after it
        if (currentUrl.includes("#/")) {
          currentUrl = currentUrl.replace(/#\/.*/, thisRoute);
        } else {
          // If it doesn't, just append the route to the base URL
          currentUrl = currentUrl.replace(/\/$/, "") + thisRoute;
        }

        window.location.replace(currentUrl);
      }
    });

    let currency = $("body")
      .find(".profileDetail .currentBalanceNew")
      .children("b").length;
    if (currency > 1) {
      $("body #mainBetslip").addClass("currencySelector");
    } else {
      $("body #mainBetslip").removeClass("currencySelector");
    }

    $(document).ready(function () {
      // Automatically focus the input field on page load

      let debounceTimer;

      // Focus on input when form is focused
      $("form").on("focus", function () {
        $("#code_match").focus();
      });

      function calculatePrice(value) {
        if (!value) {
          value = $("body #placeBetAreaValue").val();
        }
        var totalValue = 1;
        var totalKoef = 1;

        itemArray.forEach((item) => {
          totalValue = totalValue * item.coefVal;
        });
        totalValue = totalValue * value;

        const size = $("#systemBtn").val();

        if (size && size !== "-1") {
          const odds = [];

          itemArray.forEach((element) => {
            odds.push(element.coefVal);
          });

          var s = getCombinations(odds, size);
          var r = treatCombinations(s);

          $("body #winningPrice")[0].innerHTML = `${Utils.formatNumber(
            r.min
          )} / ${Utils.formatNumber(r.newMax)}`;
        } else {
          document.getElementById("winningPrice").textContent =
            Utils.formatNumber(totalValue);
        }

        $("body .koefVal").text((+totalKoef).toFixed(2));
      }
      calculatePrice();

      // Handle input change with debounce
      $("body").on("keyup", "#code_match", async function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const codeId = $(this).val().trim();

        clearTimeout(debounceTimer);
        allowEnterToSelect = false;

        if (codeId.length === 0) {
          $("body #code-match-name").text("").addClass("hidden");
          return;
        }

        debounceTimer = setTimeout(async () => {
          if (isRequestInProgress) return;

          isRequestInProgress = true;
          try {
            const data = await getMatchByCode(codeId);

            if (data.length > 0) {
              updateMatchDisplay(data[0]);
              updateCustomDropdown(data);
              allowEnterToSelect = true;
            } else {
              $("body #code-match-name").text("").addClass("hidden");
              allowEnterToSelect = false;
            }
          } catch (err) {
            console.error("Error fetching match by code:", err);
            allowEnterToSelect = false;
          } finally {
            isRequestInProgress = false;
          }
        }, 10);
      });

      $("body").on("focus", "#native-match-select", function () {
        $("body #code-match-name").addClass("hidden").text("");
      });

      // Handle Enter key in input to open dropdown
      $("body ").on("keypress", "#code_match", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();

          if (allowEnterToSelect) {
            $("body #code-match-name").addClass("hidden").text("");
            $("body #native-match-select").focus();
          }
        }
      });

      $("body").on("keypress", "#native-match-select", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          // Check if an actual option (not the placeholder) is selected
          const selectedVal = $(this).val();
          if (!selectedVal || selectedVal === "") {
            // Just reset the form fields
            $("#code_match").val("").focus();
            $("#code-match-name").text("").addClass("hidden");
            return;
          }

          // Proceed to submit if valid option
          $("form").trigger("submit");
        }
      });

      $("form").on("keydown", function (event) {
        if (event.key === "+" || event.key === "=") {
          event.preventDefault();
          $("#placeBetAreaValue").focus();
        }
      });

      $("body").on("keypress", "#placeBetAreaValue", function (event) {
        if (
          itemArray.length === 0 &&
          $(event.currentTarget).val().length === 0
        ) {
          $("body .closeModal").click();
        }
        if (event.key === "Enter") {
          event.preventDefault();
          const value = $(this).val().trim();
          if (value !== "") {
            $("#betBtn").trigger("click");
          }
        }
      });

      function updateMatchDisplay(match) {
        let matchText = `${match[0].home_team} - ${match[0].away_team}`;
        $("#code-match-name").text(matchText).removeClass("hidden");
      }

      function updateCustomDropdown(data) {
        let $select = $("body #native-match-select");
        $select.empty(); // Clear previous options

        let flatData = data.flat(); // Flatten in case of nested structure

        $select.append(`<option value="">${_t("Select an option")}</option>`); // Default option

        flatData.forEach((match) => {
          if (!match || !match.odd) return;

          let $option = $("<option></option>")
            .text(`${match.quick_name || "Unknown"}`)
            .val(match.id || "-")
            .attr("match-code", match.game_code || "-")
            .attr("match-odd", match.odd || "-")
            .attr("match-home-name", match.home_team || "Unknown")
            .attr("match-name", match.game_name || "Unknown")
            .attr("match-away-name", match.away_team || "Unknown")
            .attr("match-market", match.market)
            .attr("match-market-option", match.market_option)
            .attr("coef-id", match.id || "-")
            .attr("game-id", match.game_id || "-");

          $select.append($option);
        });
      }
      // Handle keyboard navigation and reopening dropdown when using arrows
      // $(document).on('keydown', function (event) {
      //     let $options = $('#custom-select-options .option-item');

      //     // If dropdown is open, pressing Enter selects the option
      //     if (dropdownOpen && event.key === 'Enter') {
      //         event.preventDefault();
      //         if (selectedIndex >= 0) {
      //             let selectedValue = $options.eq(selectedIndex);
      //             $('#selected-option').text(selectedValue.text());
      //             $('#custom-select-options').addClass('hidden');
      //             dropdownOpen = false;
      //             optionSelected = true; // Mark as selected

      //             $('body #code_match').blur();
      //             $('#code-match-name').text('').addClass('hidden');
      //         }
      //     }

      //     // If an option is selected and Enter is pressed again, trigger form submission
      //     else if (!dropdownOpen && optionSelected && event.key === "Enter") {
      //         event.preventDefault();
      //         $('#code_match').val('');
      //         $('#native-match-select').val('');
      //         $('form').trigger('submit'); // Trigger form submission
      //     }

      //     // If dropdown is closed and space is pressed, reopen it
      //     if (!dropdownOpen && event.key === " " && $('#selected-option').is(':focus')) {
      //         event.preventDefault();
      //         toggleDropdown(true);
      //     }
      // });

      function updateBetSlipAddedStatus() {
        $("body .bettingBtn").each(function () {
          const $btn = $(this);
          const btnCoefId = $btn.attr("coef-id") || $btn.attr("bet-id");
          const btnGameId = $btn.attr("game-id");

          const isMatch = itemArray.some(
            (item) => item.coefId === btnCoefId && item.gameId === btnGameId
          );

          if (isMatch) {
            $btn.addClass("betSlipAdded");
          } else {
            $btn.removeClass("betSlipAdded");
          }
        });
      }

      // Prevent form submission & log selected match data
      $("form").on("submit", function (event) {
        event.preventDefault();

        let selectedOption = $("#native-match-select option:selected");
        if (selectedOption.length === 0) return; // Prevent errors if no option is selected

        let matchData = {
          coefId: selectedOption.attr("coef-id"),
          coefVal: selectedOption.attr("match-odd"),
          gameName: selectedOption.attr("match-home-name"),
          getHomeName: selectedOption.attr("match-home-name"),
          getGameCode: selectedOption.attr("match-code"),
          getAwayName: selectedOption.attr("match-away-name"),
          matchMarket: selectedOption.attr("match-market"),
          marketOption: selectedOption.attr("match-market-option"),
          gameId: selectedOption.attr("game-id"),
        };

        itemArray.push(matchData);
        localStorage.setItem("addObject", JSON.stringify(itemArray));

        updateBetSlipAddedStatus();
        $(".betCount span").text(itemArray.length);

        $(".betSlipContent").append(`
                    <div class="betSlipSingleItem flex flex-row flex-wrap relative bg-black/30 w-full px-1 py-[1px] mb-[1px] last:border-none" game-id="${selectedOption.attr(
                      "game-id"
                    )}" bet-id="${selectedOption.attr("game-id")}">
                        <div class="betSlipSingleContent flex flex-wrap flex-row flex-1">
                            <div class="betSlipSingleDetails flex flex-wrap flex-row relative w-full">
                                <span class="betSlipSingleMatch flex flex-wrap flex-row text-white text-[11px] w-[35px]">${selectedOption.attr(
                                  "match-code"
                                )}</span>
                                <span class="betSlipSingleMatch flex flex-wrap flex-row text-white text-[11px] w-[270px]">${selectedOption.attr(
                                  "match-home-name"
                                )} - ${selectedOption.attr("match-away-name")}</span>
                                <span class="betSlipSingleType flex flex-wrap flex-row text-white text-[10px] w-[160px] justify-start">${selectedOption.attr(
                                  "match-market"
                                )} ( ${selectedOption.attr("match-market-option")})</span>
                                <div class="betSlipSingleOdd flex flex-wrap flex-row justify-end text-white text-[11px] w-[30px]  ${selectedOption.attr(
                                  "coef-id"
                                )}-bs">
                                    <span class="text-[11px] text-white">${selectedOption.attr(
                                      "match-odd"
                                    )}</span>
                                </div>
                            </div>
                        </div>
                        <div class="removeBetBtn w-[14px] h-[14px] p-0 cursor-pointer">
                            <img src="./img/x.gif" class="w-full h-full object-contain object-center" />
                        </div>
                    </div>
                `);

        function calculatePrice(value) {
          if (!value) {
            value = document.getElementById("placeBetAreaValue").value;
          }
          var totalValue = 1;
          var totalKoef = 1;

          itemArray.forEach((item) => {
            totalValue = totalValue * item.coefVal;
          });
          itemArray.forEach((item) => {
            totalKoef = totalKoef * +item.coefVal;
          });
          totalValue = totalValue * value;

          const size = $("#systemBtn").val();

          if (size && size !== "-1") {
            const odds = [];

            itemArray.forEach((element) => {
              odds.push(element.coefVal);
            });

            var s = getCombinations(odds, size);
            var r = treatCombinations(s);

            $("#winningPrice")[0].innerHTML = `${Utils.formatNumber(
              r.min
            )} / ${Utils.formatNumber(r.newMax)}`;
          } else {
            document.getElementById("winningPrice").textContent =
              Utils.formatNumber(totalValue);
          }

          $("body .koefVal").text((+totalKoef).toFixed(2));
        }

        calculatePrice();
        updateItemArray(itemArray);

        $("#code_match").val("").focus();
        $("#native-match-select").val(""); // reset select to default

        // dropdownOpen = false;
        // optionSelected = false;
        // selectedIndex = -1;

        // Refocus input & restore match name
        setTimeout(() => {
          $("#code_match").focus(); // Refocus input
        }, 10);
      });
    });

    let betslipDOM = document.getElementById("betslip");
    async function checkOnHoldBets() {
      let currency = $("body")
        .find(".profileDetail .currentBalanceNew")
        .children("b").length;
      if (currency > 1) {
        $("body #mainBetslip").addClass("currencySelector");
      } else {
        $("body #mainBetslip").removeClass("currencySelector");
      }
      const onHoldBetId = localStorage.getItem("onHoldBetId");
      if (onHoldBetId && onHoldBetId != "0") {
        let dataToSend = {};

        if (localStorage.getItem("for-user")) {
          dataToSend["children_id"] = localStorage.getItem("for-user");
        }

        const result = await checkOnHoldBetStatus(onHoldBetId, dataToSend);

        if (result && result.bet_state_id && result.bet_state_id != 1) {
          if (result.bet_state_id == 3 && result.negotiated_values) {
            itemArray = JSON.parse(localStorage.getItem("onHoldBet"));
            $("body #messageModal").removeClass("hidden");
            $("body .bettingBtn").removeClass("betSlipAdded");

            const newCoeficients = result.negotiated_values.split(",");

            await newCoeficients.forEach(async (element) => {
              const newCoefId = element.split("|")[0];
              const newCoefOdd = element.split("|")[1];
              let itemArrayItem = itemArray.find((a) => a.coefId == newCoefId);
              itemArrayItem.oldCoefVal = itemArrayItem.coefVal;
              itemArrayItem.coefVal = newCoefOdd;
            });

            localStorage.setItem("addObject", JSON.stringify(itemArray));
            betslipDOM.innerHTML = await Betslip.render();
            await Betslip.after_render();
            $("body .loaderWrapper-bet").remove();
            $("#mainBetslip").addClass("slideDown");
            $("body").on("click", ".currencySelector", function (e) {
              $(e.currentTarget).parent().children().removeClass("selected");
              $(e.currentTarget).addClass("selected");
            });

            let currency = $("body")
              .find(".profileDetail .currentBalanceNew")
              .children("b").length;
            if (currency > 1) {
              $("body #mainBetslip").addClass("currencySelector");
            } else {
              $("body #mainBetslip").removeClass("currencySelector");
            }
            $("body").addClass("betSlipOpened");
            $("#btnDescription").text("Prano ndryshimet");
            $("body #messageModal")
              .removeClass("showMessage")
              .addClass("hidden");
            $("body #negotiationModal")
              .addClass("showMessage flex")
              .removeClass("hidden");
            setTimeout(async function () {
              $("body #negotiationModal")
                .removeClass("showMessage")
                .addClass("hidden");
            }, 2000);
            $("body #placeBetAreaValue").val(playedValue);
            $("body #placeBetValue").text(playedValue);
            calculatePrice(playedValue);
          } else if (result.bet_state_id == 2) {
            // alert("Bileta u pranua");
            $("body #confirmationModal")
              .addClass("showMessage flex")
              .removeClass("hidden");
            setTimeout(async function () {
              $("body #confirmationModal")
                .removeClass("showMessage")
                .addClass("hidden");
              $("body #messageModal")
                .removeClass("showMessage")
                .addClass("hidden");
              $("body .bettingBtn").removeClass("betSlipAdded");
              itemArray = [];
              localStorage.setItem("addObject", JSON.stringify(itemArray));
              localStorage.removeItem("coefHasChanged");
              betslipDOM.innerHTML = await Betslip.render();
            }, 2000);
            $("body .loaderWrapper-bet").remove();
          } else {
            // alert("Bileta u refuzua: " + result.refused_message);
            $("body #refusedModal")
              .addClass("showMessage flex")
              .removeClass("hidden");
            setTimeout(function () {
              $("body #messageModal")
                .removeClass("showMessage")
                .addClass("hidden");
              $("body .bettingBtn").removeClass("betSlipAdded");
              $("body #refusedModal")
                .removeClass("showMessage")
                .addClass("hidden");
              $("body #refusedModal")
                .children()
                .children("p")
                .text(result.refused_message);
            }, 2000);

            $("body .loaderWrapper-bet").remove();
          }

          localStorage.removeItem("onHoldBet");
          localStorage.removeItem("onHoldBetId");
          localStorage.removeItem("for-user");
        }
      }
    }

    $("body").on("keyup", "#placeBetAreaValue", function () {
      if ($("body #placeBetAreaValue").val().includes(",")) {
        $("body #placeBetAreaValue").val(
          $("body #placeBetAreaValue").val().replace(",", ".")
        );
      }
      if ($("body #placeBetAreaValue").value == 0) {
        $("body #placeBetValue").text("0");
        calculatePrice(0);
      } else {
        $("body #placeBetValue").text($("body #placeBetAreaValue").val());
        calculatePrice($("body #placeBetAreaValue").val());
      }
    });

    $("body").on("click", ".repeatTicket", async function (e) {
      let currency = $("body")
        .find(".profileDetail .currentBalanceNew")
        .children("b").length;
      if (currency > 1) {
        $("body #mainBetslip").addClass("currencySelector");
      } else {
        $("body #mainBetslip").removeClass("currencySelector");
      }
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const betId = $(e.currentTarget).attr("bet-id");
      const bet = await repeatbetinfo(betId);

      itemArray = [];

      for (let index = 0; index < bet.length; index++) {
        const element = bet[index];
        itemArray.push({
          coefId: element.coefId,
          coefVal: element.coefVal,
          gameId: element.gameId,
          gameName: element.gameName,
          getAwayName: element.getAwayName,
          getHomeName: element.getHomeName,
          matchMarket: element.matchMarket,
        });
      }

      localStorage.setItem("addObject", JSON.stringify(itemArray));
      betslipDOM.innerHTML = await Betslip.render();
    });

    let allowRequest = true;
    let betBtn = $("body #betBtn");

    if (betBtn) {
      $("body")
        .off("click", "#betBtn")
        .one("click", "#betBtn", async (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          const confirmBet = confirm(
            "Jeni i sigurtë që dëshironi të vendosni këtë biletë?"
          );
          if (!confirmBet) return;

          if (allowRequest) {
            allowRequest = false;
            $("body").addClass("requestHasBeenMade");

            $("body").on("click", ".currencySelector", function (e) {
              $(e.currentTarget).parent().children().removeClass("selected");
              $(e.currentTarget).addClass("selected");
            });

            let currency = $("body")
              .find(".profileDetail .currentBalanceNew")
              .children("b").length;
            if (currency > 1) {
              $("body #mainBetslip").addClass("currencySelector");
            } else {
              $("body #mainBetslip").removeClass("currencySelector");
            }
            let coefHasChanged = localStorage.getItem("coefHasChanged");
            if (coefHasChanged) {
              $("#btnDescription").text("Place Bet");
              $("#valueIcon").text("");
              calculatePrice(0);
              localStorage.removeItem("coefHasChanged");
              allowRequest = true;
            }
            if (!localStorage.getItem("role")) {
              $("body .loginBtn").click();
            } else {
              if (
                $("body #placeBetAreaValue").val() == "" ||
                (JSON.parse(localStorage.getItem("addObject")) || []).length ==
                  0
              ) {
                allowRequest = true;
                alert(
                  "please place a betting price or add any game on betslip"
                );
              } else {
                $("body").append(
                  `<div class="loaderWrapper-bet fixed inset-0 z-[99999] bg-black/50 flex items-center justify-center">
                            <div class="w-10 h-10 border-2 border-white/10 border-t-4 border-t-white rounded-full animate-spin"></div>
                        </div>`
                );

                const system = $("#systemBtn").val();
                let data = {
                  total_sum: $("body #placeBetAreaValue").val(),
                  cnk_value: system == "-1" ? "0" : system,
                  bet_data: [],
                };

                (JSON.parse(localStorage.getItem("addObject")) || []).forEach(
                  (item) => {
                    data.bet_data.push({
                      coeficient_id: item.coefId,
                      coeficient_value: item.coefVal,
                    });
                  }
                );

                if ($("#userSelect").val()) {
                  data["children_id"] = $("#userSelect").val();
                  localStorage.setItem("for-user", $("#userSelect").val());
                }

                if ($("body #mainBetslip").hasClass("currencySelector")) {
                  let currencyId = $("body #mainBetslip")
                    .find(".currencySelector.selected")
                    .attr("currencyid");
                  data.currency = currencyId;
                }
                const result = await bet(data);
                playedValue = data.total_sum;

                if (result.success) {
                  //alert(result.message);

                  $("body .loaderWrapper-bet").remove();
                  if (result.success == "OK") {
                    allowRequest = true;
                    if (result.is_on_hold && result.is_on_hold == "1") {
                      allowRequest = false;
                      $("body").append(
                        `<div class="loaderWrapper-bet fixed inset-0 z-[99999] bg-black/50 flex items-center justify-center">
                            <div class="w-10 h-10 border-2 border-white/10 border-t-4 border-t-white rounded-full animate-spin"></div>
                        </div>`
                      );
                      localStorage.setItem(
                        "onHoldBet",
                        JSON.stringify(itemArray)
                      );
                      localStorage.setItem(
                        "onHoldBetId",
                        result.on_hold_bet_id
                      );
                    } else {
                      if (!mobileAndTabletCheck()) {
                        //const bet = await myBet()
                      }
                    }
                  }

                  localStorage.setItem("addObject", JSON.stringify(itemArray));
                  document.getElementById("winningPrice").innerHTML = "0";

                  betslipDOM.innerHTML = await Betslip.render();
                  await Betslip.after_render();
                  allowRequest = true;

                  $("body #messageModal")
                    .addClass("showMessage flex")
                    .removeClass("hidden");
                  $("body #messageModal")
                    .children()
                    .children("p")
                    .text(result.message);

                  if (
                    result.message === "Basti u vu me sukses" ||
                    result.message === "Bileta u pranua"
                  ) {
                    $("body .closeModal").click();
                    if (localStorage.getItem("autoprint") === "true") {
                      const userId = localStorage.getItem("user_id").toString();
                      // Disable printing for user cimi48, with id 38184
                      if (userId !== "38184") {
                        const bet = await mybet(result.on_hold_bet_id);
                        const doc = getGamePrintDetails(bet);

                        var printWin = window.open(
                          "",
                          "",
                          "left=0,top=0,width=900,height=700,toolbar=0,scrollbars=0,status  =0"
                        );
                        printWin.document.write(doc);
                        printWin.document.close();
                        printWin.focus();
                        printWin.print();
                        printWin.onafterprint = function () {
                          printWin.close();
                        };
                      }
                    }
                  }

                  if (result.message !== "Basti eshte ne pritje") {
                    setTimeout(function () {
                      $("body #messageModal")
                        .removeClass("showMessage")
                        .addClass("hidden");
                    }, 2000);
                  }

                  if (result.changed_coefs && result.changed_coefs.length > 0) {
                    for (
                      let index = 0;
                      index < result.changed_coefs.length;
                      index++
                    ) {
                      const changedCoef = result.changed_coefs[index];
                      var bs = document.getElementsByClassName(
                        changedCoef.coeficient_id + "-bs"
                      );
                      if (bs) {
                        for (let i = 0; i < bs.length; i++) {
                          let element = bs[i];
                          const oldPrice = element.getAttribute("match-odd")
                            ? element.getAttribute("match-odd")
                            : element.outerText;
                          if (
                            Utils.formatNumber(
                              changedCoef.coeficient_system_value
                            ) == Utils.formatNumber(oldPrice)
                          )
                            continue;
                          let color =
                            parseFloat(
                              Utils.formatNumber(
                                changedCoef.coeficient_system_value
                              )
                            ) > parseFloat(Utils.formatNumber(oldPrice))
                              ? "green"
                              : "red";

                          element.setAttribute(
                            "match-odd",
                            Utils.formatNumber(changedCoef.odd)
                          );
                          element.innerHTML = `<span style=" text-decoration: line-through;">${Utils.formatNumber(
                            oldPrice
                          )}</span><span style="color:${color}">${parseFloat(
                            Utils.formatNumber(
                              changedCoef.coeficient_system_value
                            )
                          )}</span>`;
                        }
                      }

                      localStorage.setItem("coefHasChanged", coefHasChanged);
                      $("#btnDescription").text("Prano ndryshimet");
                      $("#valueIcon").text("");
                      $("#placeBetValue").text("");

                      updateCoefLocalStorage(
                        changedCoef.coeficient_id,
                        changedCoef.coeficient_system_value
                      );
                      allowRequest = true;
                      $("body #placeBetAreaValue").focus();
                    }
                  }
                  // setTimeout(function () {
                  //   $("body #messageModal").removeClass("showMessage").addClass('hidden');
                  // }, 2000);
                  // $("body .bettingBtn ").removeClass("betSlipAdded");
                }
              }
            }

            if (localStorage.getItem("access_token")) {
              var currentBalanceResult = await getCurrentBalance();
              var coins = [];
              var allText = "";

              if (currentBalanceResult && currentBalanceResult.total_coins) {
                var allCoins = currentBalanceResult.total_coins.split("|");

                if (currentBalanceResult.total_coins.includes("|")) {
                  var allCoins = currentBalanceResult.total_coins.split("|");

                  for (let index = 0; index < allCoins.length; index++) {
                    const coin = allCoins[index];
                    const currency = coin.split(";")[0].split(".")[1];
                    coins.push({
                      currency,
                      id: coin.split(";")[0].split(".")[0],
                    });

                    const value = coin.split(";")[1];
                    allText += `<b>${currency} ${parseFloat(
                      value
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</b>`;
                  }
                } else {
                  if (currentBalanceResult.currency) {
                    coins.push({
                      currency: currentBalanceResult.currency,
                      id: currentBalanceResult.currency_id,
                    });
                    allText += `<b>${
                      currentBalanceResult.currency
                    } ${parseFloat(
                      currentBalanceResult.total_coins
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</b>`;
                  } else {
                    const currency = currentBalanceResult.total_coins
                      .split(";")[0]
                      .split(".")[1];
                    coins.push({
                      currency,
                      id: currentBalanceResult.total_coins
                        .split(";")[0]
                        .split(".")[0],
                    });

                    const value =
                      currentBalanceResult.total_coins.split(";")[1];
                    allText += `<b>${currency} ${parseFloat(
                      value
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</b>`;
                  }
                }

                $(".currentBalanceNew").html(allText);

                localStorage.setItem("coins", JSON.stringify(coins));
              }
            }
          } else {
          }
        });
    }
    if ((JSON.parse(localStorage.getItem("addObject")) || []).length >= 3) {
      $("body .betTypeWrapper").addClass("systemAvailable");
      $(".betSlipSingleItem").each(function (i) {
        if (i === 1) {
          $("#systemBtn").append('<option value="-1">System</option>');
        }
        if (i >= 2) {
          $("#systemBtn").append(
            '<option value="' +
              i +
              '">' +
              i +
              "/" +
              (JSON.parse(localStorage.getItem("addObject")) || []).length +
              "</option>"
          );
        }
      });
    } else {
      $("body .betTypeWrapper").removeClass("systemAvailable");
    }
    setInterval(checkOnHoldBets, 2000);
    if ((JSON.parse(localStorage.getItem("addObject")) || []).length == 0) {
      $("body .betSlip").addClass("hideMe");
    }

    $("body .betBalance i").text(
      $(".profileDetail .currentBalanceValue").text()
    );
  },
};
var i = 0;
function getCombinations(input, size) {
  var results = [],
    result,
    mask,
    total = Math.pow(2, input.length);
  for (mask = 0; mask < total; mask++) {
    result = [];
    i = input.length - 1;
    do {
      if ((mask & (1 << i)) !== 0) {
        result.push(input[i]);
      }
    } while (i--);

    //ne qofte se duhen edhe bastet teke edhe vareja duhet ky rresht
    // if (result.length <= size && result.length > 0) {
    //perndryshe duhet ky
    if (result.length == size && result.length > 1) {
      results.push(result);
    }
  }
  //console.log(results);
  return results;
}

function treatCombinations(s) {
  var min = false;
  var max = [];
  var maxOdd = false;
  var arr = s;
  var l = arr.length;
  let value = 0;
  let element = document.getElementById("placeBetAreaValue");
  if (element && element.value) value = parseFloat(element.value) / l;

  var i = 0;
  for (; i < l; ) {
    (function (q) {
      var odd = value;
      for (var j in q) {
        odd = odd * q[j];
      }
      if (!min) {
        min = odd;
      } else if (odd < min) {
        min = odd;
      }
      if (!maxOdd) {
        maxOdd = odd;
      } else if (odd > maxOdd) {
        maxOdd = odd;
      }
      max.push(odd);
    })(arr[i]);
    i = i + 1;
  }

  let newMax = 0;
  for (let index = 0; index < max.length; index++) {
    const element = max[index];
    newMax += element;
  }

  return {
    min: min,
    max: max,
    maxOdd: maxOdd,
    combNo: l,
    newMax,
  };
}

function calculatePrice(value) {
  if (!value) {
    value = document.getElementById("placeBetAreaValue").value;
  }
  let totalValue = 1;

  itemArray.forEach((item) => {
    totalValue = totalValue * item.coefVal;
  });
  totalValue = totalValue * value;

  const size = $("#systemBtn").val();

  if (size && size !== "-1") {
    const odds = [];

    itemArray.forEach((element) => {
      odds.push(element.coefVal);
    });

    var s = getCombinations(odds, size);
    var r = treatCombinations(s);

    $("#winningPrice")[0].innerHTML = `${Math.round(r.min * 100) / 100} / ${
      Math.round(r.newMax * 100) / 100
    }`;
  } else {
    document.getElementById("winningPrice").textContent =
      Utils.formatNumber(totalValue);
  }
}
function mobileAndTabletCheck() {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

async function renderChildUsers() {
  let users = await getUsers();
  let childrenUsers = users.data.children_users;

  let view = ``;

  for (let index = 0; index < childrenUsers.length; index++) {
    const element = childrenUsers[index];
    if (element.state === "1") {
      view += `<option value="${element.id}"> 
        ${element.username}   
      </option>`;
    }
  }

  return view;
}

export default Betslip;
